import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { GoalDescriptionModal } from "./goal-description.modal";

@NgModule({
    declarations: [GoalDescriptionModal],
    imports: [CommonModule,  IonicModule],
    exports: [GoalDescriptionModal]
})

export class GoalDescriptionModalModule {}
